// ############# * ROUTES VARIANTS * ###########################################
export const routeContainerVariantsHome = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.1
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      delay: 0.2,
      ease: 'ease'
    }
  }
};

export const routeContainerVariants = {
  hidden: { opacity: 0, scale: 2 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.2
    }
  },
  exit: {
    scale: 2,
    opacity: 0,
    transition: {
      duration: 0.2,
      delay: 0.2,
      ease: 'ease'
    }
  }
};

export const sectionVariants = {
  hidden: {
    scale: 0.6,
    opacity: 0,
    transition: {
      delay: 0.2,
      duration: 0.2
    }
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      delay: 0.2,
      duration: 0.3
    }
  }
};

// ############# * CARDS VARIANTS * ###########################################

export const cardContainer = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2
    }
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      staggerDirection: 1,
      delayChildren: 0.2
    }
  },
  exit: { transition: { staggerChildren: 0.1 } }
};

export const cardContainerInvert = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2
    }
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      staggerDirection: -1,
      delayChildren: 0.2
    }
  },
  exit: { transition: { staggerChildren: 0.1 } }
};

let easing = [0.175, 0.85, 0.42, 0.96];

export const cardItemVariants = {
  hidden: {
    opacity: 0,
    y: 200
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      ease: easing,
      type: 'spring',
      stiffness: 50,
      damping: 10,
      mass: 0.5,
      velocity: 10
    }
  },
  exit: {
    scale: 0.6,
    y: -200,
    opacity: 0,
    transition: { duration: 0.1, ease: easing }
  }
};

// ############# * SIDEBAR VARIANTS * ##########################################

export const sidebarContainer = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

export const sidebarItems = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};
